/**
 * Counts the number of `true` values in the column
 */
export function countTrue(values) {
    return values.filter((v) => v === true).length;
}
/**
 * Counts the number of occurrences of each value in the column
 */
export function histogram(values) {
    return values.reduce((acc, v) => {
        acc[v] || (acc[v] = 0);
        acc[v] += 1;
        return acc;
    }, {});
}
/**
 * Finds the lowest and highest values in the column
 */
export function minAndMax(values) {
    return {
        max: Math.max(...values),
        min: Math.min(...values)
    };
}
//# sourceMappingURL=aggregations.js.map